import { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useAuth, useCustomHistory, useModal } from '@/hooks'

import { uiActions } from '@/redux/actions'
import Toggles from '@domain/toggles/Toggles'

const NavigateTo = () => {
	const dispatch = useDispatch()
	const { modalUnmount } = useModal()
	const navigateTo = useSelector(state => state.ui.navigateTo, shallowEqual)
	const history = useCustomHistory()

	const { authenticate } = useAuth()
	const userAccount = useSelector(state => state.auth.account, shallowEqual)

	useEffect(() => {
		if (!navigateTo?.path) {
			return
		}
		if (navigateTo?.requiredUserStatus && !userAccount) {
			return
		}

		modalUnmount()
		
		if (
			!navigateTo?.requiredUserStatus ||
			(navigateTo?.requiredUserStatus && userAccount.status >= navigateTo?.requiredUserStatus)
		) {
			history.push(navigateTo?.path, navigateTo?.state)
			endNavigation()
		} else {

			authenticate('qualification', { mandatoryQualification: true }).catch(() => endNavigation())
		}
	}, [navigateTo, userAccount])

	const endNavigation = () => {
		dispatch(uiActions.navigationEnd())
	}

	return null
}

export default NavigateTo
